export default {
  static_qr_id: 'Static QR ID',
  create_static_qr: 'Create Static QR',
  qr_thumbnail: 'Thumbnails',
  qr_code_detail: 'Static QR Code Detail',
  qr_link: 'QR Link',
  tag: 'Tag',
  enter_remark: 'Enter remark',
  enter_tag: 'Enter tag',
  download_qr_code: 'Download QR Code',
  example: 'Example (for reference only):',
  view_transaction_details: 'View transaction details',
}